import React, { memo } from "react";
import { Image, StyleSheet, View, TouchableOpacity } from "react-native";
import Text from "@components/CustomText";
import DbManagement from "@assets/images/HomepageWidget/dbManagement.png";
import Received from "@assets/images/HomepageWidget/received.png";
import Sorting from "@assets/images/HomepageWidget/sorting.png";
import DeliveryTask from "@assets/images/HomepageWidget/deliveryTask.png";
import ChevronRight from "@assets/svg/ChevronRight";
import color from "@constants/color";
import Tag from "@components/Tag";
import { useNavigation } from "@react-navigation/native";
import { width } from "@constants/metrics";
import LoadingComponent from "./LoadingComponent";

const SmallWidget = memo(({ item }) => {
  const navigation = useNavigation();
  const getImage = (type) => {
    switch (type) {
      case "db-management":
        return DbManagement;
      case "received":
        return Received;
      case "sorting":
        return Sorting;
      case "pending-delivery":
        return DeliveryTask;
      // Partner Routing & Packing entry points re-use the existing
      // illustrations (truck for routing, delivery boy for packing).
      // Backend gates visibility via is_cmo_cp on widgets endpoint;
      // no separate frontend assets needed.
      case "cp-routing":
        return DbManagement;
      case "item-packing":
        return DeliveryTask;
      default:
        return null;
    }
  };

  const isloading = (key) => {
    return item?.loading?.includes(key);
  };

  return (
    <TouchableOpacity
      testID="hpw-small-widget"
      style={styles.container}
      activeOpacity={0.8}
      disabled={item?.nav_to === ""}
      onPress={() => {
        if (item?.nav_to) {
          navigation.navigate(item?.nav_to, { nav_params: item?.nav_params });
        }
      }}
    >
      <View style={styles.content}>
        <Text variant="body_text_4">{item?.title}</Text>
        {item?.value ? (
          <LoadingComponent
            visible={!isloading("value")}
            style={styles.valueLoading}
          >
            <Text variant="heading_24" style={styles.value}>
              {item?.value}
            </Text>
          </LoadingComponent>
        ) : (
          <View style={styles.placeholder} />
        )}
        {item?.caption_txt ? (
          <View style={styles.captionTxtContainer}>
            <Text variant="caption_2">{item?.caption_txt}</Text>
          </View>
        ) : null}
        <View style={styles.captionValueContainer}>
          {item?.caption_value ? (
            <LoadingComponent
              visible={!isloading("caption_value")}
              style={styles.captionValueLoading}
            >
              <Text variant="subtitle_20" style={styles.captionValue}>
                {item?.caption_value}
              </Text>
            </LoadingComponent>
          ) : null}
          {item?.caption2_text ? (
            <View style={styles.captionTagContainer}>
              <Tag text={item?.caption2_text} bgcolor={color.plain_red} />
            </View>
          ) : null}
        </View>
      </View>
      <View style={styles.chevronContainer}>
        <ChevronRight
          pathFill={color.lightMediumBlack}
          style={styles.chevronIcon}
        />
      </View>

      <Image source={getImage(item?.type)} style={styles.image} />
    </TouchableOpacity>
  );
});

export default SmallWidget;

const styles = StyleSheet.create({
  container: {
    width: width / 2 - 22,
    backgroundColor: color.white,
    height: 169,
    borderRadius: 16,
    elevation: 2,
    padding: 12,
    overflow: "hidden",
    marginHorizontal: 6,
    marginVertical: 8,
  },
  content: {
    flexDirection: "column",
    justifyContent: "flex-start",
  },
  value: {
    color: color.black06,
    lineHeight: 30,
  },
  placeholder: {
    height: 6,
  },
  captionTxtContainer: {
    backgroundColor: color.lightGrey,
    padding: 2,
    paddingHorizontal: 6,
    borderRadius: 10,
    alignSelf: "flex-start",
  },
  captionValue: {
    marginTop: 4,
  },
  valueLoading: {
    marginVertical: 2,
    width: "50%",
  },
  captionValueLoading: {
    marginTop: 4,
    width: "50%",
  },
  captionTagContainer: {
    marginTop: 4,
    marginLeft: 8,
  },
  chevronContainer: {
    backgroundColor: color.lightGrayWhite,
    padding: 3,
    borderRadius: 4,
    bottom: 10,
    position: "absolute",
    left: 10,
  },
  chevronIcon: {
    height: 16,
    width: 16,
  },
  image: {
    bottom: 0,
    right: 0,
    position: "absolute",
    height: 85,
    width: 115,
    resizeMode: "contain",
  },
  captionValueContainer: {
    flexDirection: "row",
    justifyContent: "flex-start",
  },
});
